import { AuthenticatedUserGuard } from './auth.guard';
import { RestrictedGuideGuard } from './restrict-guide.guard';

export const SHARED_GUARDS = [AuthenticatedUserGuard, RestrictedGuideGuard];
